import { withGalleryProps } from 'viewModel/gallery/withGalleryProps';
import Gallery from 'components/Community/Gallery/Gallery';

export default withGalleryProps(Gallery);
